import {
  ActionIcon,
  Badge,
  Button,
  Modal,
  Text,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { getComplianceStatus } from "../apis/userApis";
import BusinessUnitName from "../componenets/getBuName";
import {
  getDepartmentText,
  getComplianceBadgeColor,
  infoColor,
  getDateStatus,
  getStatusColor,
  getStatusText,
  csvDownload,
} from "./utilities";
import { IconEye, IconHistory, IconRefresh } from "@tabler/icons-react";
import DoughnutChart from "../componenets/DoughnutChart";
import DoughnutChart3 from "../componenets/DoughnutChart3";
import DoughnutChart2 from "../componenets/DoughnutChart2";
import DoughnutChart4 from "../componenets/DoughnutChart4";
import { useNavigate } from "react-router-dom";
import ObligationTranHistoryModal from "./ObligationTranHistoryModal";
import { IconInfoCircle } from "@tabler/icons-react";
import { getCookiesSession } from "../cookiesSession";
import TablePagination from "../componenets/Common/TablePagination";
import UniversalTable from "../componenets/Common/UniversalTable";

const DashboardCompliance = () => {
  const cookie = getCookiesSession("LawSignaUserDataMaster");

  let userData = {
    loginAs: {},
    userRole: [],
    department: null,
    businessUnit: null,
    role: "",
  };

  try {
    if (cookie) {
      const cookieData = JSON.parse(cookie);
      userData = {
        ...userData,
        ...(cookieData?.user || {}),
      };
    }
  } catch (err) {
    console.error("Invalid user session", err);
  }

  const loginAsName =
    userData && userData.loginAs && userData.loginAs.name
      ? userData.loginAs.name
      : "";

  const [uiConfig, setUiConfig] = useState({
    obligations: null,
    loading: true,
  });
  const [countConfig, setCountConifg] = useState({
    page: 1,
    count: 0,
    pageSize: 10,
  });
  const [filtersForData, setFiltersForData] = useState({
    compliant: null,
    department:
      loginAsName === "CXO" ||
      loginAsName === "DeptAdmin" ||
      loginAsName === "DeptUser"
        ? userData.department
        : null,

    businessUnit: loginAsName === "COO" ? userData.businessUnit : null,
    extraCol1: null,
    mapRegion: null,
  });
  const [csvData, setCsvData] = useState([]);
  const [compliantData, setCompliantData] = useState(null);
  const [businessUnitData, setBusinessUnitData] = useState(null);
  const [departmentData, setDepartmentData] = useState(null);
  const [agreementData, setAgreementData] = useState(null);
  const [ahModal, setAhModal] = useState(false);
  const [ahId, setAhId] = useState(0);
  const [labels, setLabels] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const getData = async () => {
      const filterdata = Object.fromEntries(
        Object.entries(filtersForData).filter(([key, value]) => value !== null),
      );
      const response = await getComplianceStatus({
        filters: filterdata,
        page: countConfig.page,
        pageSize: countConfig.pageSize,
      });
      console.log(response);
      setUiConfig({
        loading: false,
        obligations: response.obligations,
      });
      setCountConifg({
        ...countConfig,
        count: response.count,
      });
      setCompliantData(response.compliantStatusCount);
      setBusinessUnitData(response.businessUnitCount);
      setDepartmentData(response.departmentCount);
      setAgreementData(response.agreementCount);
      setCsvData(response.exportData);
    };
    getData();
  }, [countConfig.page, filtersForData, countConfig.pageSize]);
  const onViewClick = (id) => {
    navigate(`/viewobligation/${id}`);
  };

  const onExport = async () => {
    if (csvData.length > 0) {
      const columnHeaders = Object.keys(csvData[0]);
      csvDownload({
        data: csvData,
        headers: columnHeaders,
        name: "dashboard_obligations",
      });
    }
  };
  const [expandedId, setExpandedId] = useState(null); // Tracks the currently expanded obligation by ID
  useEffect(() => {
    if (!Array.isArray(departmentData) || departmentData.length === 0) {
      setLabels([]);
      return;
    }
    const generateLabels = async () => {
      const resolvedLabels = await Promise.all(
        departmentData.map(async (item) => {
          const deptText = await getDepartmentText(item.department);
          return `${deptText}/${item._count.id}`;
        }),
      );
      setLabels(resolvedLabels);
    };

    if (departmentData?.length > 0) {
      generateLabels();
    }
  }, [departmentData]);
  const handleExpand = (id) => {
    setExpandedId(id); // Set the ID of the obligation to expand
  };

  const headers = [
    {
      label: "no.",
      align: "center",
      render: (row, index) => (
        <Text size="sm" weight={500} color="dimmed">
          {(countConfig.page - 1) * countConfig.pageSize + (index + 1)}
        </Text>
      ),
    },
    {
      label: "title",
      render: (row) => (
        <Text size="sm" weight={600} className="text-slate-700">
          {row.title}
        </Text>
      ),
    },
    {
      label: "obligation",
      render: (row) => (
        <div
          style={{ cursor: "pointer", maxWidth: "250px" }}
          onClick={() => handleExpand(row.id)}
        >
          <Text
            size="sm"
            color="dark.3"
            lineClamp={expandedId === row.id ? undefined : 2}
          >
            {row.desc}
          </Text>
        </div>
      ),
    },
    { label: "contract category", key: "extraCol1", align: "center" },
    { label: "BU", key: "businessUnit", align: "center" },
    { label: "second party", key: "connectedParty", align: "center" },
    {
      label: "department",
      render: (row) => <Text size="sm">{row.dept?.name || "--"}</Text>,
    },
    {
      label: "assignee",
      align: "center",
      render: (row) => <Text size="sm">{row.assignTo?.name || "Unassigned"}</Text>,
    },
    {
      label: "compliance",
      align: "center",
      render: (row) => (
        <Badge
          variant="light"
          radius="xl"
          size="sm"
          color={getComplianceBadgeColor(row.compliant)}
        >
          {row.compliant}
        </Badge>
      ),
    },
    {
      label: "timeline",
      align: "center",
      render: (row) => {
        const status = getDateStatus(
          row.createdAt,
          row.duedate,
          row.reminderTime,
        );
        return (
          <Badge
            variant="light"
            radius="xl"
            size="sm"
            color={getStatusColor(status)}
          >
            {getStatusText(status)}
          </Badge>
        );
      },
    },
    {
      label: "actions",
      align: "center",
      render: (row) => (
        <div className="flex flex-row justify-center gap-1">
          <ActionIcon
            onClick={() => onViewClick(row.id)}
            variant="subtle"
            // color="blue"
            radius="md"
            color="#1b6f8d"
          >
            <IconEye size={18} stroke={1.5} color="#1b6f8d" />
          </ActionIcon>
          <ActionIcon
            onClick={() => {
              setAhId(row.id);
              setAhModal(true);
            }}
            variant="subtle"
            color="gray"
            radius="md"
          >
            <IconHistory size={18} stroke={1.5} />
          </ActionIcon>
          {row.extraCol3 !== "" && (
            <ActionIcon variant="subtle" radius="md">
              <IconInfoCircle
                color={infoColor(row.extraCol3)}
                size={18}
                stroke={1.5}
              />
            </ActionIcon>
          )}
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="m-4">
        <div className="dashboard-header">
          <div className="dashboard-header-left">
            <h1 className="dashboard-heading">Compliance Overview</h1>
            <p className="dashboard-subtitle">
              Real-time snapshot of obligation compliance across your organization
            </p>
          </div>
          <div className="dashboard-header-right">
            <ActionIcon
              className="my-auto"
              onClick={() =>
                setFiltersForData({
                  compliant: null,
                  department:
                    userData.role === "CXO" ||
                    userData.role === "DeptAdmin" ||
                    userData.role === "DeptUser"
                      ? userData.department
                      : null,
                  businessUnit:
                    userData.role === "COO" ? userData.businessUnit : null,
                  connectedAgreement: null,
                })
              }
            >
              <IconRefresh size={30} />
            </ActionIcon>
            <Button className="ml-4" onClick={onExport}>
              Export
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {compliantData !== null && (
            <div className="chart-container pt-4 pb-2">
              <Text className="font-medium block text-center">Compliance</Text>
              <div className="flex justify-center p-4">
                <DoughnutChart
                  compliantData={compliantData}
                  filtersForData={filtersForData}
                  setFiltersForData={setFiltersForData}
                  labels={compliantData.map(
                    (item) => `${item.compliant}/${item._count.id}`,
                  )}
                  datafor={compliantData.map((item) => item._count.id)}
                />
              </div>
            </div>
          )}
          {businessUnitData !== null && (
            <div className="chart-container pt-4 pb-2">
              <Text className="font-medium block text-center">
                Business Unit
              </Text>
              <div className="flex justify-center p-4">
                <DoughnutChart2
                  businessUnitData={businessUnitData}
                  filtersForData={filtersForData}
                  setFiltersForData={setFiltersForData}
                  labels={businessUnitData.map(
                    (item) => `${item.name}/${item._count.id}`,
                  )}
                  datafor={businessUnitData.map((item) => item._count.id)}
                />
              </div>
            </div>
          )}
          {departmentData !== null && (
            <div className="chart-container pt-4 pb-2">
              <Text className="font-medium block text-center">Function</Text>
              <div className="flex justify-center p-4">
                <DoughnutChart3
                  departmentData={departmentData}
                  filtersForData={filtersForData}
                  setFiltersForData={setFiltersForData}
                  labels={labels}
                  datafor={departmentData.map((item) => item._count.id)}
                />
              </div>
            </div>
          )}
          {agreementData !== null && (
            <div className="chart-container pt-4 pb-2">
              <Text className="font-medium block text-center">
                Connected Contract
              </Text>
              <div className="flex justify-center p-4">
                <DoughnutChart4
                  agreementData={agreementData}
                  filtersForData={filtersForData}
                  setFiltersForData={setFiltersForData}
                  labels={agreementData.map(
                    (item) => `${item.extraCol1 + ""}/${item._count.id}`,
                  )}
                  datafor={agreementData.map((item) => item._count.id)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      {uiConfig.obligations !== null && (
        <>
          <UniversalTable
            headers={headers}
            data={uiConfig.obligations}
            loading={false} // Connect your loading state here
          />

          <TablePagination
            totalCount={countConfig.count}
            page={countConfig.page}
            pageSize={countConfig.pageSize}
            dataLength={uiConfig.obligations?.length || 0}
            onPageChange={(val) =>
              setCountConifg({ ...countConfig, page: val })
            }
            onPageSizeChange={(val) =>
              setCountConifg({ ...countConfig, pageSize: val, page: 1 })
            }
          />
        </>
      )}
      <Modal
        opened={ahModal}
        onClose={() => {
          setAhModal(false);
          setAhId(0);
        }}
        title="oblligation action history"
        size="calc(80vw)"
      >
        <ObligationTranHistoryModal id={ahId} />
      </Modal>
    </>
  );
};

export default DashboardCompliance;
